import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

const hasCommission = () => {
  const user = store.state.main.user;
  return user && user.data.commissionType !== "none";
};

export default {
  routes: [
    {
      name: "user-commission-paid",
      path: "commission/paid",
      meta: {
        auth: hasCommission,
        hideFromIndex: true,
        icon: "commission",
        title: i18n.global.t("Commission"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/Commission"),
    },
    {
      name: "user-commission-search",
      path: "commission/search/:query?",
      meta: {
        auth: hasCommission,
        hideFromIndex: true,
        icon: "commission",
        title: i18n.global.t("Commission"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/Commission"),
    },
    {
      name: "user-commission",
      path: "commission/:dialog?",
      props: true,
      meta: {
        auth: hasCommission,
        icon: "commission",
        title: i18n.global.t("Commission"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/Commission"),
    },
  ],

  dialogs: [
    {
      name: "user-commission-view",
      path: "/sales-tools/commission/:commissionID/view",
      meta: {},
      component: () => import("../../../dialogs/employee/CommissionView"),
    },
  ],
};
